import { render, staticRenderFns } from "./UploadQuestions.vue?vue&type=template&id=0da17672&scoped=true&"
import script from "./UploadQuestions.vue?vue&type=script&lang=js&"
export * from "./UploadQuestions.vue?vue&type=script&lang=js&"
import style0 from "./UploadQuestions.vue?vue&type=style&index=0&id=0da17672&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da17672",
  null
  
)

export default component.exports